export class TimeValidationParams {
    constructor(
        public readonly startTime: number,
        public readonly endTime: number,
        public readonly timeList: number[],
        public readonly step: number
    ){
    }
}



// WEBPACK FOOTER //
// ./src/app/slick-grid/models/time-validation-params.ts